var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Text } from '@inter-ikea-kompis/component-text';
import { Button as SkapaButton, IconButton as SkapaIconButton } from '@ingka/button-webc/passive.js';
import { arrowLeft, cross, registerIcon } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import SheetHeaderStyle from './SheetHeaderStyle.js';
/**
 * SheetHeader component.
 *
 * @event closeButtonClick Triggered when the user clicks on the back button icon.
 * @event backButtonClick When next button is clicked.
 */
export default class SheetHeader extends KompisElement {
    constructor() {
        super(...arguments);
        // Heading
        this.heading = null;
        // Z-index.
        this.zIndex = 501;
        // Floating header.
        this.floatingHeader = false;
        // Back icon as default.
        this.backIcon = false;
        // Label for the close icon button to set as an aria-label for accessibility reasons. There is a common translation modalAriaLabelButtonClose you can use.
        this.ariaLabelCloseButton = null;
        // Label for the back icon button to set as an aria-label for accessibility reasons. There is a common translation modalAriaLabelButtonBack you can use.
        this.ariaLabelBackButton = null;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${SheetHeaderStyle.getStyle({
            theme: this.theme,
            zIndex: this.zIndex,
            floatingHeader: this.floatingHeader
        })}
			</style>
			<div class="headingContainer">
				${this.getBackButton()}
				<h2 class="header">
					<kompis-text .theme="${this.theme}" .type="${ThemeFontStyleTypeEnum.headingSmall}"
						>${this.heading}</kompis-text
					>
				</h2>
				${this.getCloseButton()}
			</div>
		`;
    }
    async connectedCallback() {
        registerIcon(arrowLeft);
        registerIcon(cross);
        this.customElements.define('skapa-button', SkapaButton);
        this.customElements.define('skapa-icon-button', SkapaIconButton);
        this.customElements.define('skapa-icon', SkapaIcon);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * @returns Close button.
     */
    getCloseButton() {
        const buttonVariant = this.floatingHeader ? 'primary' : 'tertiary';
        return html `
			<skapa-icon-button
				class="crossIcon"
				variant="${buttonVariant}"
				?inverse="${this.floatingHeader ? true : false}"
				size="small"
				@click="${this.onCloseClick.bind(this)}"
			>
				<skapa-icon slot="icon" icon="cross"></skapa-icon>
				${this.ariaLabelCloseButton || ''}
			</skapa-icon-button>
		`;
    }
    /**
     * On close click event.
     */
    onCloseClick() {
        this.dispatchEvent(new CustomEvent('closeButtonClick', { bubbles: true, detail: { type: 'button' } }));
    }
    /**
     * @returns Back button.
     */
    getBackButton() {
        if (!this.backIcon) {
            return html `<div class="filler"></div>`;
        }
        const buttonVariant = this.floatingHeader ? 'primary' : 'tertiary';
        return html `
			<skapa-icon-button
				class="backIcon"
				variant="${buttonVariant}"
				?inverse="${this.floatingHeader ? true : false}"
				size="small"
				@click="${this.onBackClick.bind(this)}"
			>
				<skapa-icon flip-rtl slot="icon" icon="arrow-left"></skapa-icon>
				${this.ariaLabelBackButton || ''}
			</skapa-icon-button>
		`;
    }
    /**
     * On back click event.
     */
    onBackClick() {
        this.dispatchEvent(new CustomEvent('backButtonClick', { bubbles: true, detail: { type: 'button' } }));
    }
}
__decorate([
    property({ type: String })
], SheetHeader.prototype, "heading", void 0);
__decorate([
    property({ type: Object, required: true })
], SheetHeader.prototype, "theme", void 0);
__decorate([
    property({ type: Number })
], SheetHeader.prototype, "zIndex", void 0);
__decorate([
    property({ type: Boolean })
], SheetHeader.prototype, "floatingHeader", void 0);
__decorate([
    property({ type: Boolean })
], SheetHeader.prototype, "backIcon", void 0);
__decorate([
    property({ type: String })
], SheetHeader.prototype, "ariaLabelCloseButton", void 0);
__decorate([
    property({ type: String })
], SheetHeader.prototype, "ariaLabelBackButton", void 0);
//# sourceMappingURL=SheetHeader.js.map